import * as React from "react";
import styled from "styled-components";
import Input from "reactstrap/lib/Input";
import { FormGroup } from "reactstrap";

const InputText = styled.p`
  font-style: normal;
  font-weight: bold;
  line-height: normal;
  font-size: 11px;
  color: #828282;
  margin-bottom: 0;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
`;

const StyledInput = styled(Input)`
  border: none !important;
  outline: none;
  box-shadow: none !important;

  :focus {
    outline: none !important;
  }
`;

const StyledFormGroup = styled(FormGroup)`
  margin-bottom: 0 !important;
`;

interface props {
  InputTitleText?: string;
  InputPlaceholderText?: string;
  type?: any;
  rightBorder?: boolean;
  onChange?: ((value: string) => void);
}

const InputFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-right: ${(p: props) => (p.rightBorder ? "1px solid #bdbdbd" : "none")};
  padding-bottom: 4px;

  input {
    padding-left: 16px;
  }
`;

class InputForm extends React.Component<props, any> {
  render() {
    return (
      <InputFormContainer rightBorder={this.props.rightBorder}>
        <InputText>{this.props.InputTitleText}</InputText>
        <StyledFormGroup>
          <StyledInput
            placeholder={this.props.InputPlaceholderText}
            type={this.props.type}
            onChange={event => {
              this.props.onChange && this.props.onChange(event.target.value);
            }}
          />
        </StyledFormGroup>
      </InputFormContainer>
    );
  }
}

export default InputForm;



// WEBPACK FOOTER //
// ./src/components/FormComponents/InputForm.tsx